// Generated by scripts/scope-tours/order.ts. Do not edit by hand.
// The order the library teaches its modules in, read from the docs: sections
// as the library has them, modules within a section by the docs sidebar
// position of the page they cite, then by that page's heading order. A scope
// missing here sorts last.
export const CURRICULUM: string[] = [
    'view:Dashboard',
    'view:DashboardComments',
    'view:Document',
    'view:Tags',
    'view:SpotlightTableConfig',
    'view:MetricsTree',
    'view:PinnedItems',
    'view:Space',
    'view:SavedChart',
    'manage:ExportCsv',
    'manage:Dashboard',
    'create:DashboardComments',
    'manage:DashboardComments',
    'manage:Document',
    'manage:SavedChart',
    'manage:Tags',
    'create:Space',
    'manage:Space',
    'manage:ProjectHomepage',
    'manage:PinnedItems',
    'manage:ContentVerification',
    'manage:VerifiedContent',
    'manage:DeletedContent',
    'manage:Explore',
    'manage:CustomFields',
    'manage:SqlRunner',
    'manage:CustomSqlTableCalculations',
    'view:CompiledSql',
    'view:UnderlyingData',
    'manage:ChangeCsvResults',
    'create:VirtualView',
    'delete:VirtualView',
    'manage:VirtualView',
    'view:AiAgent',
    'create:AiAgentThread',
    'manage:AiAgent',
    'create:AiDeepResearch',
    'manage:AiAgentDocument',
    'create:DataApp',
    'view:DataApp',
    'manage:DataApp',
    'manage:Validation',
    'manage:SpotlightTableConfig',
    'manage:MetricsTree',
];
